import CreateWindow from "../../puzzles/puzzleWindow";
import magazine2D from "./images/lehti.jpg";
import magazine2DSve from "./images/Lehti_ruotsiksi.jpg";
import magazine2DEn from "./images/Lehti_englanniksi.jpg";
import energiajuoma from "./images/energiajuoma.jpg";
import energiajuomaSve from "./images/energiajuoma_ruottiks.jpg";
import energiajuomaEn from "./images/energiajuoma_englanniksi.jpg"
import jakoavain from "./images/wrench.jpg";
import jakoavainSve from "./images/jakoavain_ruottiks.jpg";
import jakoavainEn from "./images/jakoavain_englanniksi.jpg";
import jalkapallo from "./images/jalkapallo.jpg";
import jalkapalloSve from "./images/jalkapallo_ruottiks.jpg";
import jalkapalloEn from "./images/jalkapallo_englanniksi.jpg"
import kanisteri from "./images/kanisteri.jpg";
import kanisteriSve from "./images/kanisteri_ruottiks.jpg";
import kanisteriEn from "./images/kanisteri_englanniksi.jpg"
import kirja from "./images/kirja.jpg";
import kirjaSve from "./images/kirja_ruottiks.jpg";
import kirjaEn from "./images/kirja_englanniksi.jpg"
import lapio from "./images/lapio.jpg";
import lapioSve from "./images/lapio_ruottiks.jpg";
import lapioEn from "./images/lapio_englanniksi.jpg"
import spraymaali from "./images/Spraymaali.jpg";
import spraymaaliSve from "./images/Spraymaali_ruottiks.jpg";
import spraymaaliEn from "./images/Spraymaali_englanniksi.jpg"
import { html, render } from "lit-html";
import "./index.css";
import { tips } from "~/src/tips";
import { exitButtonPosition } from "../../helpers/exitButtonPosition";

const pictures = () => {
  console.log(process.env.LANGUAGE)
  console.log(process.env.BABEL_ENV)
  if(process.env.LANGUAGE === "sve") {
    return {
      wrench: jakoavainSve,
      energydrink: energiajuomaSve,
      football: jalkapalloSve,
      fuelCan: kanisteriSve,
      book: kirjaSve,
      shovel: lapioSve,
      sprayCan: spraymaaliSve,
      magazine: magazine2DSve
    }
  }
  else if(process.env.LANGUAGE === "en") {
   
    return {
      wrench: jakoavainEn,
      energydrink: energiajuomaEn,
      football: jalkapalloEn,
      fuelCan: kanisteriEn,
      book: kirjaEn,
      shovel: lapioEn,
      sprayCan: spraymaaliEn,
      magazine: magazine2DEn
    }
  }
  else return {
      wrench: jakoavain,
      energydrink: energiajuoma,
      football: jalkapallo,
      fuelCan: kanisteri,
      book: kirja,
      shovel: lapio,
      sprayCan: spraymaali,
      magazine: magazine2D
  }
}

export const tip2DImageLauncher = {
  wrench: () => {
    ShowImage({
      src: pictures().wrench,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  energydrink: () => {
    ShowImage({
      src: pictures().energydrink,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  football: () => {
    ShowImage({
      src: pictures().football,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  fuelCan: () => {
    ShowImage({
      src: pictures().fuelCan,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  book: () => {
    ShowImage({
      src: pictures().book,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  shovel: () => {
    ShowImage({
      src: pictures().shovel,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  sprayCan: () => {
    ShowImage({
      src: pictures().sprayCan,
      callbackBeforeRender: () => null,
      exitCallback: () => null
    });
  },
  magazine: () => {
    ShowImage({
      src: pictures().magazine,
      callbackBeforeRender: () => tips.magazine.clear(),
      exitCallback: () => {
        tips.cameraLocker.setTime(40);
      },
    });
  },
};

const ShowImage = function ({ src, callbackBeforeRender, exitCallback }) {
  const markup = html`
    <div class="plain-2d-image-container">
      <img src=${src} class="plain-2d-image" />
    </div>
  `;

  
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const puzzleWindow = CreateWindow({ exitCallback }).element;

  if(typeof callbackBeforeRender === "function") {
    callbackBeforeRender();
  }
  render(markup, puzzleWindow);

  exitButtonPosition();
};

export default ShowImage;
